<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="6" md="5" sm="6" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col v-if="!internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer From</legend>
                  <v-select ref="fromAccountSelected" solo :items="fromFormattedAccounts" item-value="id"
                    item-text="displayText" append-icon="mdi-chevron-down" label="Select From Account"
                    class="custom-select" hide-details="auto" @change="fromAccountSelected"></v-select>
                </fieldset>
                <span v-if="error.fromAccountError" class="error-message">
                  {{ error.fromAccountError }}
                </span>
              </v-col>
              <v-col v-if="!internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer To</legend>
                  <v-select ref="toAccountSelected" solo :items="toFormattedAccounts" item-value="id"
                    item-text="displayText" append-icon="mdi-chevron-down" label="Select From Account"
                    class="custom-select" hide-details="auto" @change="toAccountSelected"></v-select>
                </fieldset>
                <span v-if="error.toAccountError" class="error-message">
                  {{ error.toAccountError }}
                </span>
              </v-col>
              <!-- <v-col
                v-if="!internalTransferDetails?.otpsent"
                cols="12"
                sm="12"
                md="12"
              >
                <fieldset>
                  <legend>Enter Amount (USD)</legend>
                  <v-text-field
                    type="number"
                    v-model="amount"
                    label="Enter Amount"
                    single-line
                    solo
                    hide-details="auto"
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
                <span v-if="error.amount_error" class="error-message">
                  {{ error.amount_error }}
                </span>
              </v-col> -->

              <v-col cols="12" sm="12" md="12" v-if="!internalTransferDetails?.otpsent">
                <fieldset>
                  <legend>Amount <span v-if="amount">(₹ {{ amount * inrrate }})</span></legend>
                  <v-text-field min="1" v-model="amount" label="$" type="number" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
                <span v-if="error.amount_error" class="error-message">
                  {{ error.amount_error }}
                </span>
              </v-col>

              <v-col cols="12" sm="12" md="12" v-if="this.currency.name !== 'USD' && !internalTransferDetails?.otpsent">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line
                    solo hide-details class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col v-if="internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Enter OTP Code</legend>
                  <v-text-field type="number" v-model="verifiedCode" @input="limitDigits" @keydown="onKeyDown"
                    label="Verify Code" single-line solo hide-details="auto" class="custom-select"></v-text-field>
                </fieldset>
                <span v-if="error.code_error" class="error-message">
                  {{ error.code_error }}
                </span>
              </v-col>

              <v-col v-if="internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <v-btn @click.prevent="submitForm" :loading="loading2" :disabled="loading2" tile elevation="0"
                  class="ma-0 text-capitalize btn-account d-block w-100" color="greenMain">
                  Submit
                </v-btn>
              </v-col>
              <v-col v-if="!internalTransferDetails?.otpsent" cols="12" sm="12" md="12">
                <v-btn :loading="loading" :disabled="loading" @click.prevent="handleForm" tile elevation="0"
                  class="ma-0 text-capitalize btn-account d-block w-100" color="greenMain">
                  Send
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col xl="4" lg="4" md="7" sm="6" cols="12">
          <div class="card-wrapper-box mt-2">
            <v-card v-if="fromAccount" @click="fromDialog = true"
              class="elevation-0 rounded-0 deposit-form-card from-card"
              :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
              <div class="ribbon"><span>From</span></div>
              <v-card-actions>
                <div class="trade-status">
                  <div>
                    <v-icon color="greenMain">mdi-signal</v-icon>
                  </div>
                  <div class="trade-number">
                    <span>MT5 - {{ this.fromAccount?.account_type_display }}</span>
                    <span>{{ this.fromAccount?.trading_account_no }}</span>
                  </div>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="value-trades">
                  <span>Balance</span>
                  <span>{{ this.fromAccount?.Balance }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="value-trades">
                  <span>Currency</span>
                  <span>{{ this.fromAccount?.currency_name }}</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
                  <div>
                    <apexChart width="100%" height="95px" type="line" :options="options" :series="[
                      { name: 'Equity/Balance', data: seriesforFromAccount },
                    ]">
                    </apexChart>
                  </div>
                </v-sheet>
              </v-card-actions>
              <v-card-actions>
                <div class="currency-leverage">
                  <span>Equity</span>
                  <span>{{ this.fromAccount?.Equity }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="currency-leverage">
                  <span>Leverage</span>
                  <span>{{ this.fromAccount?.leverage }}:1</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="balance-equity">
                  <span>Free Margin</span>
                  <span>{{ this.fromAccount?.MarginFree }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="balance-equity">
                  <span>Acc. Type</span>
                  <span>{{ this.fromAccount?.account_type_display }}</span>
                </div>
              </v-card-actions>
            </v-card>
            <v-dialog v-model="fromDialog" width="320">
              <v-card class="elevation-0 rounded-0 deposit-form-card from-card"
                :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <div class="ribbon"><span>From</span></div>
                <v-card-actions>
                  <div class="trade-status">
                    <div>
                      <v-icon color="greenMain">mdi-signal</v-icon>
                    </div>
                    <div class="trade-number">
                      <span>MT5 -
                        {{ this.fromAccount?.account_type_display }}</span>
                      <span>{{ this.fromAccount?.trading_account_no }}</span>
                    </div>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="value-trades">
                    <span>Balance</span>
                    <span>{{ this.fromAccount?.Balance }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="value-trades">
                    <span>Currency</span>
                    <span>{{ this.fromAccount?.currency_name }}</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'
                    ">
                    <div>
                      <apexChart width="100%" height="95px" type="line" :options="options" :series="[
                        {
                          name: 'Equity/Balance',
                          data: seriesforFromAccount,
                        },
                      ]">
                      </apexChart>
                    </div>
                  </v-sheet>
                </v-card-actions>
                <v-card-actions>
                  <div class="currency-leverage">
                    <span>Equity</span>
                    <span>{{ this.fromAccount?.Equity }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="currency-leverage">
                    <span>Leverage</span>
                    <span>{{ this.fromAccount?.leverage }}:1</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="balance-equity">
                    <span>Free Margin</span>
                    <span>{{ this.fromAccount?.MarginFree }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="balance-equity">
                    <span>Acc. Type</span>
                    <span>{{ this.fromAccount?.account_type_display }}</span>
                  </div>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card v-if="toAccount" @click="toDialog = true" class="elevation-0 rounded-0 deposit-form-card to-card"
              :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
              <div class="ribbon"><span>To</span></div>
              <v-card-actions>
                <div class="trade-status">
                  <div>
                    <v-icon color="greenMain">mdi-signal</v-icon>
                  </div>
                  <div class="trade-number">
                    <span>MT5 - {{ this.toAccount?.account_type_display }}</span>
                    <span>{{ this.toAccount?.trading_account_no }}</span>
                  </div>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="value-trades">
                  <span>Balance</span>
                  <span>{{ this.toAccount?.Balance }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="value-trades">
                  <span>Currency</span>
                  <span>{{ this.toAccount?.currency_name }}</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
                  <div>
                    <apexChart width="100%" height="95px" type="line" :options="options"
                      :series="[{ name: 'Equity/Balance', data: seriesData }]">
                    </apexChart>
                  </div>
                </v-sheet>
              </v-card-actions>
              <v-card-actions>
                <div class="currency-leverage">
                  <span>Equity</span>
                  <span>{{ this.toAccount?.Equity }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="currency-leverage">
                  <span>Leverage</span>
                  <span>{{ this.toAccount?.leverage }}:1</span>
                </div>
              </v-card-actions>
              <v-card-actions>
                <div class="balance-equity">
                  <span>Free Margin</span>
                  <span>{{ this.toAccount?.MarginFree }}</span>
                </div>
                <v-spacer></v-spacer>
                <div class="balance-equity">
                  <span>Acc. Type</span>
                  <span>{{ this.toAccount?.account_type_display }}</span>
                </div>
              </v-card-actions>
            </v-card>
            <v-dialog v-model="toDialog" width="320">
              <v-card class="elevation-0 rounded-0 deposit-form-card to-card"
                :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <div class="ribbon"><span>To</span></div>
                <v-card-actions>
                  <div class="trade-status">
                    <div>
                      <v-icon color="greenMain">mdi-signal</v-icon>
                    </div>
                    <div class="trade-number">
                      <span>MT5 - {{ this.toAccount?.account_type_display }}</span>
                      <span>{{ this.toAccount?.trading_account_no }}</span>
                    </div>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="value-trades">
                    <span>Balance</span>
                    <span>{{ this.toAccount?.Balance }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="value-trades">
                    <span>Currency</span>
                    <span>{{ this.toAccount?.currency_name }}</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'
                    ">
                    <div>
                      <apexChart width="100%" height="95px" type="line" :options="options"
                        :series="[{ name: 'Equity/Balance', data: seriesData }]">
                      </apexChart>
                    </div>
                  </v-sheet>
                </v-card-actions>
                <v-card-actions>
                  <div class="currency-leverage">
                    <span>Equity</span>
                    <span>{{ this.toAccount?.Equity }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="currency-leverage">
                    <span>Leverage</span>
                    <span>{{ this.toAccount?.leverage }}:1</span>
                  </div>
                </v-card-actions>
                <v-card-actions>
                  <div class="balance-equity">
                    <span>Free Margin</span>
                    <span>{{ this.toAccount?.MarginFree }}</span>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="balance-equity">
                    <span>Acc. Type</span>
                    <span>{{ this.toAccount?.account_type_display }}</span>
                  </div>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRANSACTION__ACTIONS } from "@/store/action-types";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      loading2: false,
      fromDialog: false,
      toDialog: false,
      verifiedCode: null,
      fromClient_trading_account_id: null,
      toClient_trading_account_id: null,
      fromAccount: null,
      toAccount: null,
      amount: null,
      currencyAmount: '',
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color: "#fff"
      },
      error: {
        fromAccountError: null,
        toAccountError: null,
        amount_error: null,
        code_error: null,
      },
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
    };
  },

  computed: {
    ...mapState("transactions", [
      "internaltransferAccount",
      "internalTransfer",
      "internalTransferDetails",
    ]),
    ...mapState("deposit", ["inrrate"]),

    fromFormattedAccounts() {
      if (
        this.internaltransferAccount &&
        Array.isArray(this.internaltransferAccount)
      ) {
        const filteredAccounts = this.internaltransferAccount.filter(
          (item) => item.id !== this.fromClient_trading_account_id && item.trader_type !== 2
        );
        return filteredAccounts.map((account) => {
          const { id, trading_account_no, account_type_display, Balance } =
            account;
          const displayText = `${trading_account_no} (${account_type_display}) ${Balance} ${account.currency_name}`;
          return { id, displayText };
        });
      }
      return [];
    },

    toFormattedAccounts() {
      if (
        this.internaltransferAccount &&
        Array.isArray(this.internaltransferAccount)
      ) {
        const filteredAccounts = this.internaltransferAccount.filter(
          (item) => item.id !== this.fromClient_trading_account_id
        );
        return filteredAccounts.map((account) => {
          const { id, trading_account_no, account_type_display, Balance } =
            account;
          const displayText = `${trading_account_no} (${account_type_display}) ${Balance} ${account.currency_name}`;
          return { id, displayText };
        });
      }
      return [];
    },

    seriesData() {
      if (!this.toAccount) return [];

      const balance = Number(this.toAccount?.Balance) || 0;
      const equity = Number(this.toAccount?.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },

    seriesforFromAccount() {
      if (!this.fromAccount) return [];

      const balance = Number(this.fromAccount?.Balance) || 0;
      const equity = Number(this.fromAccount?.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },
  },

  watch: {
    amount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    }
  },

  methods: {
    ...mapActions("transactions", [
      TRANSACTION__ACTIONS.INTERNALTRANSFERACCOUNT,
      TRANSACTION__ACTIONS.PAYMENTMETHOD,
      TRANSACTION__ACTIONS.INTERNALTRANSFERCODE,
      TRANSACTION__ACTIONS.CONFIRMINTERNALTRANSFER,
    ]),
    ...mapActions("deposit", [DEPOSITMETHODS__ACTIONS.INRRATE]),

    limitDigits() {
      if (this.verifiedCode.length > 6) {
        this.verifiedCode = this.verifiedCode.slice(0, 6);
      }
    },

    onKeyDown(event) {
      if (event.target.value.length >= 6 && event.keyCode !== 8) {
        event.preventDefault();
      }
    },

    fromAccountSelected(selectedAccount) {
      const filter = this.internaltransferAccount.find(
        (item) => item.id === selectedAccount
      );
      this.fromClient_trading_account_id = selectedAccount;
      this.fromAccount = filter;
    },

    toAccountSelected(selectedAccount) {
      const filter = this.internaltransferAccount.find(
        (item) => item.id === selectedAccount
      );
      this.toClient_trading_account_id = selectedAccount;
      this.toAccount = filter;
      if (filter) {
        this.currency.rate = filter.currency_rate;
        this.currency.name = filter.currency_name;
        this.currency.symbol = filter.currency_symbol;
        this.currency.color = filter.symbol_color;
      }
    },

    async handleForm() {
      this.loading = true;
      try {
        if (!this.fromAccount) {
          this.error.fromAccountError = "Select from account";
          return;
        } else {
          this.error.fromAccountError = null;
        }

        if (!this.toAccount) {
          this.error.toAccountError = "Select to account";
          return;
        } else {
          this.error.toAccountError = null;
        }

        if (this.toAccount.currency_name != this.fromAccount.currency_name) {
          this.error.toAccountError = "Select same currency type accounts";
          this.error.fromAccountError = "Select same currency type accounts";
          return;
        } else {
          this.error.toAccountError = null;
        }


        if (
          Number(this.amount) <
          Number(this.internalTransfer?.[0]?.min_transaction) ||
          Number(this.amount) > this.internalTransfer?.[0]?.max_transaction
        ) {
          this.error.amount_error = `Amount must be between ${this.internalTransfer?.[0]?.min_transaction} and ${this.internalTransfer?.[0]?.max_transaction}.`;
        } else if (Number(this.amount) > Number(this.fromAccount?.Balance)) {
          this.error.amount_error = `Insufficient balance`;
        } else {
          this.error.amount_error = null;
        }

        const data = {
          fromAccountID: this.fromAccount?.id,
          toAccountID: this.toAccount?.id,
          amount: Number(this.amount),
          client_account_id: this.fromAccount.client_account_id,
          trading_account_no: this.fromAccount.trading_account_no,
        };

        if (!Object.values(this.error).some((err) => err !== null)) {
          await this[TRANSACTION__ACTIONS.INTERNALTRANSFERCODE](data);
          // this.fromAccount = null;
          // this.toAccount = null;
          // this.amount = null;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.loading2 = true;
      try {
        if (!Object.values(this.error).some((err) => err !== null)) {
          await this[TRANSACTION__ACTIONS.CONFIRMINTERNALTRANSFER]({
            code: this.verifiedCode,
          });
          this.verifiedCode = null;
          this.fromAccount = null;
          this.toAccount = null;
          this.amount = null;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading2 = false;
      }
    },
  },
  async mounted() {
    await this[TRANSACTION__ACTIONS.INTERNALTRANSFERACCOUNT]();
    await this[TRANSACTION__ACTIONS.PAYMENTMETHOD]();
    await this[DEPOSITMETHODS__ACTIONS.INRRATE]();
  },
};
</script>

<style scoped>
.error-message {
  color: #FF567F;
  font-size: 13px;
}
</style>
